import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2944">
      <Navbar data-id="element-2945" />
      <main data-id="element-2946">
        <ConsularAffairs data-id="element-2947" />
      </main>
      <Footer data-id="element-2948" />
      <FeedbackPopup data-id="element-2949" />
    </div>;
}